export interface DataEntity_Working_03_Interface {
  id: number,
  value:string,
}

export function Empty_DataEntity_Working_03_Interface(): DataEntity_Working_03_Interface {
  return {
    id: 0,
    value:'',
  }
}
